import React, { Component } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';
import clsx from 'clsx';
import { pick, isEqual } from 'lodash';

import { AsyncView } from 'components/View';

import { setPageMeta } from './duck/actions';
import styles from './Page.scss';

const propsToCompare = [
  'title',
  'showBreadcrumbs',
  'helpLink',
  'titleComponent',
];

class Page extends Component {
  static propTypes = {
    setPageMeta: PropTypes.func.isRequired,
    compressed: PropTypes.bool,
    helpLink: PropTypes.any,
    isHomePage: PropTypes.bool,
    isTabs: PropTypes.bool,
    loading: PropTypes.bool,
    showBreadcrumbs: PropTypes.bool,
    title: PropTypes.string,
    titleComponent: PropTypes.element,
    withContentWrapper: PropTypes.bool,
    withPageHeader: PropTypes.bool,
  };

  static defaultProps = {
    title: '',
    helpLink: undefined,
    showBreadcrumbs: false, // tured off for redesign
    loading: false,
    compressed: false,
    isHomePage: false,
    isTabs: false,
    titleComponent: null,
    withPageHeader: true,
    withContentWrapper: true,
  };

  componentDidMount() {
    const {
      title,
      showBreadcrumbs,
      helpLink,
      isHomePage,
      isTabs,
      titleComponent,
      withPageHeader,
      withContentWrapper,
    } = this.props;

    this.props.setPageMeta({
      title,
      showBreadcrumbs,
      helpLink,
      isHomePage,
      isTabs,
      titleComponent,
      withPageHeader,
      withContentWrapper,
    });
  }

  // TODO: replace this lifecycle event with component
  // did update or make this a functional component
  UNSAFE_componentWillReceiveProps(nextProps) {
    const currentParams = pick(this.props, propsToCompare);
    const nextParams = pick(nextProps, propsToCompare);

    if (!isEqual(currentParams, nextParams)) {
      this.props.setPageMeta(nextParams);
    }
  }

  render() {
    const { loading, compressed, error, className, children } = this.props;
    const innerCss = clsx(
      {
        [styles.innerContainer]: true,
        [styles['innerContainer--compressed']]: compressed,
      },
      styles[className],
    );

    return (
      <AsyncView loading={loading} error={error} className={innerCss}>
        {children}
      </AsyncView>
    );
  }
}

export default connect(null, { setPageMeta })(Page);
